import { useController, useLightboxState } from "yet-another-react-lightbox";

export const ViewerButton = ({ name, label, children, className = "", ...props }) => (
    <button type="button" className={`viewer-control ${className}`} aria-label={label}
        title={label} data-testid={`image-viewer-${name}`} {...props}>
        {children}
    </button>
);

export const ViewerClose = () => {
    const { close } = useController();
    return <ViewerButton name="close" label="Chiudi" className="viewer-close" onClick={close}><span aria-hidden="true">×</span></ViewerButton>;
};

export const ViewerNavigation = ({ direction }) => {
    const { currentIndex, slides } = useLightboxState();
    const controller = useController();
    if (slides.length < 2) return null;
    const previous = direction === "prev";
    return (
        <ViewerButton name={direction} label={previous ? "Immagine precedente" : "Immagine successiva"}
            className={`viewer-nav viewer-${direction}`}
            disabled={previous ? currentIndex === 0 : currentIndex === slides.length - 1}
            onClick={() => controller[direction]()}>
            <span aria-hidden="true">{previous ? "←" : "→"}</span>
        </ViewerButton>
    );
};

export const ViewerZoom = ({ zoom, minZoom, maxZoom, disabled, zoomIn, zoomOut, changeZoom }) => (
    <div className="viewer-zoom" data-testid="image-viewer-zoom-controls">
        <ViewerButton name="zoom-out" label="Riduci" disabled={disabled || zoom <= minZoom} onClick={zoomOut}>−</ViewerButton>
        <ViewerButton name="zoom-reset" label="Adatta allo schermo" className="viewer-zoom-value"
            disabled={disabled} onClick={() => changeZoom(1)}>
            <span data-testid="image-viewer-zoom-level">{Math.round(zoom * 100)}%</span>
        </ViewerButton>
        <ViewerButton name="zoom-in" label="Ingrandisci" disabled={disabled || zoom >= maxZoom} onClick={zoomIn}>+</ViewerButton>
    </div>
);

export const ViewerCaption = () => {
    const { currentSlide, currentIndex, slides } = useLightboxState();
    return (
        <>
            <div className="viewer-masthead">
                <span className="viewer-brand">APF Partners</span>
                <span className="viewer-collection" data-testid="image-viewer-collection">{currentSlide?.collection}</span>
            </div>
            <div className="viewer-footer" aria-live="polite" aria-atomic="true">
                <span className="viewer-counter" data-testid="image-viewer-counter">
                    {String(currentIndex + 1).padStart(2, "0")}<span aria-hidden="true"> / </span>
                    <span className="sr-only"> di </span>{String(slides.length).padStart(2, "0")}
                </span>
                <div className="viewer-caption">
                    <p className="viewer-caption-title" data-testid="image-viewer-caption">{currentSlide?.title || currentSlide?.alt}</p>
                    {currentSlide?.description && <p className="viewer-caption-source" data-testid="image-viewer-source">{currentSlide.description}</p>}
                </div>
            </div>
        </>
    );
};